import * as d3 from 'd3';
import { AnnotationModelItem, SvgData } from '../interfaces';

export const drawSvg = function (wrapper, item: AnnotationModelItem) {
  const data: SvgData = item.data as SvgData;

  const outputGipotenuze = Math.hypot(data.size[0] || 1, data.size[1] || 1);
  const defaultGipotenuze = Math.hypot(24, 24);
  const modifier = outputGipotenuze / defaultGipotenuze;

  const w = d3.select(wrapper);
  const newG: d3.Selection<SVGElement, unknown, null, undefined> = w.select(`#item${item.id}`).node()
    ? w.select(`#item${item.id}`)
    : w.append('g');
  newG.selectAll('*').remove();

  newG.attr('id', `item${item.id}`);

  let element = newG.html(data.element);

  newG
    .attr('stroke', data.color)
    //.attr('fill', 'none')
    .attr('fill', data.color)
    .style('stroke-width', data.strokeWidth)
    .attr('vector-effect', 'non-scaling-stroke');

  const svg = newG.select(`svg`);
  svg.attr('width', data.size[0]).attr('height', data.size[1]);
  svg.attr('vector-effect', 'non-scaling-stroke');

  //.attr('viewBox', `0 0 ${data.size[0]} ${data.size[1]}`);
  return newG;
};
